<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import ConversationHeatmapContainer from './ConversationHeatmapContainer.vue';
import ResolutionHeatmapContainer from './ResolutionHeatmapContainer.vue';

const { t } = useI18n();

// Os dois heatmaps ficavam sempre empilhados, cada um com sua grade de 24h × N
// dias — na prática o dobro da altura de scroll para ver o segundo. Viram
// abas: cada heatmap mantém seu próprio filtro de data/inbox (BaseHeatmapContainer
// não muda), só a apresentação vira abas em vez de empilhado.
// `tabs` precisa ser computed — resolvido como const uma vez, `t()` prendia o
// rótulo no locale do primeiro render (bug real: mostrou em inglês com o
// resto da página já em pt-BR).
const tabs = computed(() => [
  { id: 'traffic', label: t('OVERVIEW_REPORTS.CONVERSATION_HEATMAP.HEADER') },
  { id: 'resolutions', label: t('OVERVIEW_REPORTS.RESOLUTION_HEATMAP.HEADER') },
]);

const activeTabIndex = ref(0);
const handleTabChange = tab => {
  activeTabIndex.value = tabs.value.findIndex(t2 => t2.id === tab.id);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeTabIndex"
      @tab-changed="handleTabChange"
    />
    <div v-show="activeTabIndex === 0">
      <ConversationHeatmapContainer />
    </div>
    <div v-show="activeTabIndex === 1">
      <ResolutionHeatmapContainer />
    </div>
  </div>
</template>
